import IndexPage from '@/modules/reports/pages/IndexPage.vue'

import AiTravelReportPage from '../pages/AiTravelReportPage.vue'
import HotelReportsPage from '../pages/HotelReportsPage.vue'
import PlaneReportsPage from '../pages/PlaneReportsPage.vue'

export default {
	path: '/reports',
	children: [
		{
			path: 'hotels/legacy',
			name: 'reports.hotels.legacy',
			component: () => import('../pages/LegacyHotelReportsPage.vue'),
			meta: { title: 'Hotelería · Reporte 2.0 Legacy' },
		},
		{
			path: '',
			name: 'reports.index',
			component: IndexPage,
			redirect: { name: 'reports.hotels' },
		},
		{
			path: 'hotels',
			name: 'reports.hotels',
			component: HotelReportsPage,
			meta: {
				title: 'Reportes de Hotelería',
			},
		},
		{
			path: 'planes',
			name: 'reports.planes',
			component: PlaneReportsPage,
			meta: {
				title: 'Reportes de Aviones',
			},
		},
		{
			path: 'ai-travel',
			name: 'reports.ai-travel',
			component: AiTravelReportPage,
			meta: {
				title: 'Reporte de viajes IA',
			},
		},
	],
}
